export default {
    props: {
        pageableAlwaysVisible: {
            type: Boolean,
            default: undefined,
            kComposite: 'pageable.alwaysVisible'
        }, 
        pageablePageSize: {
            type: Number,
            default: undefined,
            kComposite: 'pageable.pageSize'
        }, 
        pageablePreviousNext: {
            type: Boolean,
            default: undefined,
            kComposite: 'pageable.previousNext'
        }, 
        pageableNumeric: {
            type: Boolean,
            default: undefined,
            kComposite: 'pageable.numeric'
        }, 
        pageableButtonCount: {
            type: Number,
            default: undefined,
            kComposite: 'pageable.buttonCount'
        }, 
        pageableInput: {
            type: Boolean,
            default: undefined,
            kComposite: 'pageable.input'
        }, 
        pageablePageSizes: {
            type: [Boolean, Array],
            default: undefined,
            kComposite: 'pageable.pageSizes'
        }, 
        pageableRefresh: {
            type: Boolean,
            default: undefined,
            kComposite: 'pageable.refresh'
        }, 
        pageableResponsive: {
            type: Boolean,
            default: undefined,
            kComposite: 'pageable.responsive'
        }, 
        pageableInfo: {
            type: Boolean,
            default: undefined,
            kComposite: 'pageable.info'
        }, 
        pageableMessagesDisplay: {
            type: String,
            default: undefined,
            kComposite: 'pageable.messages.display'
        }, 
        pageableMessagesEmpty: {
            type: String,
            default: undefined,
            kComposite: 'pageable.messages.empty'
        }, 
        pageableMessagesPage: {
            type: String,
            default: undefined,
            kComposite: 'pageable.messages.page'
        }, 
        pageableMessagesOf: {
            type: String,
            default: undefined,
            kComposite: 'pageable.messages.of'
        }, 
        pageableMessagesItemsPerPage: {
            type: String,
            default: undefined,
            kComposite: 'pageable.messages.itemsPerPage'
        }, 
        pageableMessagesFirst: {
            type: String,
            default: undefined,
            kComposite: 'pageable.messages.first'
        }, 
        pageableMessagesLast: {
            type: String,
            default: undefined,
            kComposite: 'pageable.messages.last'
        }, 
        pageableMessagesNext: {
            type: String,
            default: undefined,
            kComposite: 'pageable.messages.next'
        }, 
        pageableMessagesPrevious: {
            type: String,
            default: undefined,
            kComposite: 'pageable.messages.previous'
        }, 
        pageableMessagesRefresh: {
            type: String,
            default: undefined,
            kComposite: 'pageable.messages.refresh'
        }, 
        pageableMessagesMorePages: {
            type: String,
            default: undefined,
            kComposite: 'pageable.messages.morePages'
        }
    }
}


// WEBPACK FOOTER //
// ./packages/kendo-treelist-vue-wrapper/src/KendoTreeList/Pageable.js